import { schema } from "normalizr";

import { role } from "shared/state/Role/schema";
import { user } from "shared/state/User/schema";

export const employee = new schema.Entity("employee", { role, user });
export const employeeList = [employee];
